module.exports = __webpack_public_path__ + "img/epl.9da4ed2f.png";